import React, { forwardRef, useEffect, useState } from "react";
import Checkbox from "../../../../generic/checkbox";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
interface Type {
  id: number;
  name: string;
  fieldName: string;
}
export const ShowDetails = forwardRef((props: any, ref: any) => {
  const [selectedGuardian, setSelectedGuardian] = useState<any>();
  const [guardianOptions, setGuardianOptions] = useState<any>([]);
  const [guardianName, setGuardianName] = useState<any>("");

  useEffect(() => {
    if (props.GuardianData) {
      let guardianOpt = props.GuardianData.map((guardian: any) => {
        return { value: guardian.firstName, display: guardian.firstName };
      });
      setGuardianOptions(guardianOpt);
    }
  }, [JSON.stringify(props.GuardianData)]);
  useEffect(() => {
    if (guardianName === "" && guardianOptions.length > 0) {
      setGuardianName(guardianOptions[0].value);
      updateGuardianData(guardianOptions[0].value);
    } else {
      updateGuardianData(guardianName);
    }
  }, [guardianOptions]);

  const updateGuardianData = async (guardianName: any) => {
    if (guardianName) {
      let guardiansData = props.GuardianData.filter((guardian: any) => {
        return guardianName === guardian.firstName;
      });
      if (guardiansData.length > 0) {
        await setSelectedGuardian(guardiansData);
        let allNominee = JSON.parse(JSON.stringify(props.totalNominee));
        allNominee[props.id].guard = guardiansData[0];
        props.setTotalNominee(allNominee);
      }
    }
  };

  return (
    <>
      <div className="custom--row nomineeShare tradingAccnt">
        <div className="form-field custom-col noLeftPAdding">
          <label className="input-label">Guardian</label>
          <TocDropdown
            selectedValue={
              guardianName
                ? guardianName
                : guardianOptions && guardianOptions.length > 0
                ? guardianOptions[0].value
                : []
            }
            dropdownOptions={guardianOptions}
            onSelect={(val) => {
              setGuardianName(val);
              updateGuardianData(val);
            }}
            isSearchable={false}
          />
        </div>
        <div className="form-field custom-col noLeftPAdding"></div>
      </div>
      <div className="box">
        <div className="display-flex head">
          <p>Existing Guardian Details</p>
          {/* <p>(DP ID: 1203230001324865)</p> */}
        </div>

        <div className="custom--row tradingAccnt">
          <div className="custom-col">
            <label className="input-label">Guardian Name</label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              errorText={""}
              defaultValue={
                selectedGuardian
                  ? selectedGuardian[0].firstName +
                    ` ${selectedGuardian[0].middleName}` +
                    ` ${selectedGuardian[0].lastName}`
                  : ""
              }
            ></InputField>
          </div>
          <div className="custom-col">
            <label className="input-label">
              Guardian Relationship with Nominee
            </label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              errorText={""}
              defaultValue={selectedGuardian ? selectedGuardian[0].nomRel : ""}
            ></InputField>
          </div>
        </div>
        <div className="custom--row tradingAccnt">
          <div className="custom-col">
            <label className="input-label">Guardian Email ID</label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              errorText={""}
              defaultValue={selectedGuardian ? selectedGuardian[0].email : ""}
            ></InputField>
          </div>
          <div className="custom-col">
            <label className="input-label">Guardian Phone Number</label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              errorText={""}
              defaultValue={selectedGuardian ? selectedGuardian[0].phone : ""}
            ></InputField>
          </div>
        </div>
        <div className="custom--row tradingAccnt">
          <div className="custom-col">
            <label className="input-label">Guardian Birthdate</label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              errorText={""}
              defaultValue={
                selectedGuardian ? selectedGuardian[0].birthdate : ""
              }
            ></InputField>
          </div>
          {/* <div className="custom-col">
            <label className="input-label">Nominee % of Share</label>
            <InputField
              integer={true}
              onChange={() => {}}
              onBlur={() => {}}
              onMouseOut={() => {}}
              placeholder="100%"
              errorText={""}
              defaultValue={"100%"}
            ></InputField>
          </div> */}
        </div>
        <div className="custom--row address tradingAccnt">
          <div className="custom-col-100">
            <label className="input-label">Guardian Address</label>
            <p>
              {/* Flat no D301, Neel Vasundhara co op hog sc ltd, Vijay Park, Mira
              Road - East, Thane, Maharashtra - 401107 */}
              {selectedGuardian
                ? selectedGuardian[0].address.addr1 +
                  ` ${selectedGuardian[0].address.addr2}` +
                  ` ${selectedGuardian[0].address.addr3}` +
                  ` ${selectedGuardian[0].address.addr4}` +
                  ` ${selectedGuardian[0].address.city}` +
                  ` ${selectedGuardian[0].address.state}` +
                  ` ${selectedGuardian[0].address.pin}`
                : ""}
            </p>
          </div>
        </div>
      </div>
    </>
  );
});
